module.exports = __webpack_public_path__ + "img/back.41f2c3db.svg";